import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { req, reqPoll } from './ServerUtils';
import DesignSettings from './DesignSettings';
import { NavBar } from './Navbar';
import { makeDesign } from './utils';
import { useUser } from './UserProvider';
import HueSlider from './HueSlider';
import { IconButton, Alert, CircularProgress, Menu, Button, MenuItem } from '@mui/material';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import { shiftColorsToHue } from './Colors';
import EmblaCarouselIframes from './CarouselOfIframes';
import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import debounce from "lodash/debounce";
import useDebounce from './useDebounce';

const presets = [{
    name: 'Portrait',
    width: 600,
    height: 1200,
    icon: <CropPortraitIcon />
  }, {
    name: 'Landscape',
    width: 800,
    height: 1200,
    icon: <CropLandscapeIcon />
  }]

const downloadCode = `
<script>
    function screenshot() {
        domtoimage.toPng(document.body, {
            scale: 2
        }).then((dataUrl) => {
            window.parent.postMessage({ type: "image", data: dataUrl, page: $page }, "*");

        }).catch(e => {
            window.parent.postMessage({ type: "image", error: true, page: $page }, "*");
            console.error(e);
        });
    }
    document.addEventListener('DOMContentLoaded', async function screenshotWrapper() {
        await screenshot();
        document.removeEventListener('DOMContentLoaded', screenshotWrapper);

    });
</script>
`;

const code = `<script src="https://mmb-js.s3.us-east-1.amazonaws.com/dom-to-image-new.js"></script>
<style>
.mmb-image-background, .mmb-image {
    cursor: pointer;
}
#fonts-done {
    display: none;
}


#controls {
    position: fixed;
    display: flex;
    gap: 5px;
    background: white;
    border: 1px solid #aaa;
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    visibility: hidden;
    z-index: 10;
}
#controls button {
    border: none;
    background: #9c27b0;
    color: white;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 3px;
    font-size: 14px;
}
#controls button:hover {
    background: purple;
}
</style>
<script>
document.addEventListener('DOMContentLoaded', async function imageClickWrapper() {
    document.removeEventListener('DOMContentLoaded', imageClickWrapper);



    function addOnClick(selector, type) {
        const els = document.querySelectorAll(selector);
        for (const el of els) {
            el.addEventListener('click', (e) => {
                const elem = e.target;
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = 'image/*';
                input.style.display = 'none';
                input.onchange = e => { 
                    const file = e.target.files[0];
                    const reader = new FileReader();
                    
                    reader.onload = (readerEvent) => {
                        const content = readerEvent.target.result; 
                        if (type == 'image-background') {
                            elem.setAttribute('style', 'background-image: url(' + content + ')');
                        } else {
                            elem.setAttribute('src', content);
                        }
                    }
                    reader.readAsDataURL(file);
                    document.body.removeChild(input);
                }
                document.body.appendChild(input);
                input.click();

            });
        }
    }
    addOnClick('.mmb-image-background', 'image-background');
    addOnClick('.mmb-image', 'image');
    addOnClick('img', 'image');

    const elems = document.querySelectorAll(
        'div, span, p, a, h1, h2, h3, h4, h5, h6, li, td, th, blockquote, pre, code, label'
    );
    
    for (const elem of elems) {
        const isWatermark = elem.classList.contains('watermark');
        if (isWatermark) {
            elem.style.pointerEvents = 'none';
            elem.style.userSelect = 'none';
            elem.style.cursor = 'default';
        }
        else {
            // if elem has no children that's not a span
            let hasChildren = false;
            for (const child of elem.children) {
                if (child.tagName != 'SPAN') {
                    hasChildren = true;
                    break;
                }
            }   
            if (!hasChildren) {
                elem.setAttribute('contenteditable', 'true');
                elem.classList.add('editable');
                elem.setAttribute('spellcheck', 'false');
            }
            elem.onclick = (e) => {
                e.stopPropagation();
                e.preventDefault();
            };
        }
    }

    // add +/-, increase/decrease font size

    // <div class="controls" id="controls">
    //     <button id="increase">+</button>
    //     <button id="decrease">-</button>
    // </div>
    function addControls() {
        const controls = document.createElement('div');
        controls.id = 'controls';
        const increaseBtn = document.createElement('button');
        increaseBtn.id = 'increase';
        increaseBtn.textContent = '+';
        const decreaseBtn = document.createElement('button');
        decreaseBtn.id = 'decrease';
        decreaseBtn.textContent = '-';
        controls.appendChild(increaseBtn);
        controls.appendChild(decreaseBtn);
        document.body.appendChild(controls);

        function adjustFontSize(amount) {
            if (!selectedDiv) return;
            let currentSize = parseInt(window.getComputedStyle(selectedDiv).fontSize);
            let newSize = Math.max(10, currentSize + amount);
            selectedDiv.style.fontSize = newSize + "px";
        }

        increaseBtn.addEventListener("mousedown", (e) => {
            e.preventDefault();
            adjustFontSize(2);
        });

        decreaseBtn.addEventListener("mousedown", (e) => {
            e.preventDefault();
            adjustFontSize(-2);
        });
        return controls;
    }
    if (document.body.querySelector('#controls')) {
        return;
    }
    const controls = addControls();
    let selectedDiv = null;

    document.querySelectorAll(".editable").forEach(div => {
        div.addEventListener("focus", (e) => {
            selectedDiv = e.target;
            
            const rect = selectedDiv.getBoundingClientRect();
            const top = window.scrollY + rect.top - 40;
            controls.style.top = top + "px";
            const left = window.scrollX + rect.left;
            controls.style.left = left + "px";
            controls.style.visibility = "visible";
        });

        div.addEventListener("blur", (e) => {
            setTimeout(() => {
                if (!controls.contains(document.activeElement)) {
                    controls.style.visibility = "hidden";
                    selectedDiv = null;
                }
            }, 100);
        });
    });
    // finish add +/-, increase/decrease font size
    
});
</script>`;


const DesignEditor = ({id}) => {
    const {userInfo} = useUser();

    // const [isTablet, setIsTablet] = useState(window.matchMedia('(max-width: 600px)').matches);
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Returns true for small screens

    const { urlId } = useParams();
    const designId = urlId || id;
    // const iframeRef = useRef(null);
    // const [config, setConfig] = useState({});
    const [design, setDesign] = useState(null);
    const [htmls, setHtmls] = useState([]);
    const [preset, setPreset] = useState(presets[0]);
    
    const framesRef = useRef([]);
    const [downloading, setDownloading] = useState(false);
    const [downloadingPage, setDownloadingPage] = useState("");
    
    const [receivedImages, setReceivedImages] = useState({});
    const [format, setFormat] = useState("pdf");
    const [allowedFormats, setAllowedFormats] = useState(["pdf", "zip"]);
    const [currentSlide, setCurrentSlide] = useState(0);

    let [hue, setHue] = useState(0);
    const debouncedHue = useDebounce(hue, 200);

    const [designLoading, setDesignLoading] = useState(true);

    function onIframeBlur(i) {
        const iframeDoc = framesRef.current[i].contentDocument;
        const htmlContent = iframeDoc.documentElement.outerHTML;
        htmls[i] = htmlContent;
        setHtmls([...htmls]);
    }
    
    function restoreHtmlWithoutDownloadCode(i) {
        let iframeDoc = framesRef.current[i]
        if (!iframeDoc) return;
        iframeDoc = iframeDoc.contentDocument;
        if (!iframeDoc) return;
        iframeDoc.open();
        iframeDoc.write(htmls[i]);
        iframeDoc.close();
    }

    async function screenshotPage(i) {

        const iframeDoc = framesRef.current[i].contentDocument;
        let htmlContent = iframeDoc.documentElement.outerHTML.replace('</head>', downloadCode.replace('$page', i) + '</head>');

        iframeDoc.open();
        iframeDoc.write(htmlContent);
        iframeDoc.close();
    }
    useEffect(() => {
        const handleMessage = (event) => {
            // if (event.origin !== "https://trusted-source.com") return; // Replace with actual iframe origin
            const data = event.data
            const img = data.data, page = data.page;
            receivedImages[page] = img;
            setReceivedImages({...receivedImages});
            setDownloadingPage("page " + page);
            
            restoreHtmlWithoutDownloadCode(page);

            if (Object.keys(receivedImages).length == framesRef.current.length) {
                const images = Object.keys(receivedImages).sort((a, b) => a - b).map((key) => receivedImages[key]);

                setDownloadingPage("");
                download({format, images, setDownloading});
            } else if (page < framesRef.current.length - 1) {
                screenshotPage(page + 1);
            }
        };

        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        }
    }, [htmls]);
    
    // const handleToggle = (className) => {
    //     setConfig(prev => {
    //         const updatedConfig = {
    //             ...prev,
    //             [className]: { ...prev[className], visible: !prev[className].visible }
    //         };
    //         injectCSS(updatedConfig);
    //         return updatedConfig;
    //     });
    // };

    // const handlePropertyChange = (className, property, value) => {
    //     setConfig(prev => {
    //         const updatedConfig = {
    //             ...prev,
    //             [className]: { ...prev[className], [property]: value }
    //         };
    //         injectCSS(updatedConfig);
    //         return updatedConfig;
    //     });
    // };
    useEffect(() => {
        // simply refresh so that if there's javascript in the iframe, it gets reloaded
        // const iframeDoc = iframeRef.current?.contentDocument;
        // if (!iframeDoc || !iframeDoc.documentElement) return;
        // const html = iframeDoc.documentElement.outerHTML;
        // iframeDoc.open();
        // iframeDoc.write(html);
        // iframeDoc.close();
    }, [preset]);


    useEffect(() => {
        if (!design || design.pages.length === 0) return;
        
        // const html = design?.pages[0].template_html;
        // // const templateStyle = 'https://cdn.makemybrand.ai/template-images/carousel-13/styles.css';
        // html.match(/<link[^>]+href="([^"]+)"[^>]+>/g).forEach((link) => {
        //     const href = link.match(/href="([^"]+)"/)[1];
        //     if (href.endsWith('styles.css') && href.startsWith('https://cdn.makemybrand.ai/')) {
        //         // fetch this file
        //         const resp = fetch(href + '?t=' + Date.now());
        //         resp.then((r) => r.text()).then((css) => {
        //             const rootMatch = css.match(/:root\s*{([^}]*)}/);
        //             if (rootMatch) {
        //                 const keys = [];
        //                 const rootContent = rootMatch[1];
        //                 const matches = rootContent.match(/--[\w-]+(?=\s*:)/g);
        //                 if (matches) {
        //                     matches.forEach((key) => keys.push(key.trim()));
        //                 }
        //             }
        //         });
        //     }
        // });
        // const iframeDoc = iframeRef.current?.contentDocument;
        // if (!iframeDoc || !iframeDoc.documentElement) return;
        
        if (debouncedHue) {
            console.log("debouncedHue", debouncedHue);
            modifySlides(0, hue);
        }
    }, [debouncedHue]);

    function onHueSliderMouseUp() {
        modifySlides(0, hue);
    }

    const [hueTimeouts, setHueTimeouts] = useState([]);

    function modifySlides(i, hue) {
        const html = htmls[i];
        const iframeDoc = framesRef.current[i].contentDocument;
        if (i == 0) {
            hueTimeouts.forEach(timeout => clearTimeout(timeout));
            setHueTimeouts([]);
        }

        shiftColorsToHue(html, hue).then(newHtml => {;
            iframeDoc.open();
            iframeDoc.write(newHtml);
            iframeDoc.close();

            if (i < htmls.length - 1) {
                hueTimeouts.push(setTimeout(() => modifySlides(i + 1, hue), 200));
            }
        });
    }

    // const injectCSS = (updatedConfig) => {
    //     const iframeDoc = iframeRef.current.contentDocument;
    //     let styleTag = iframeDoc.getElementById('dynamic-styles');
    //     if (!styleTag) {
    //         styleTag = iframeDoc.createElement('style');
    //         styleTag.id = 'dynamic-styles';
    //         iframeDoc.head.appendChild(styleTag);
    //     }
    //     const css = Object.entries(updatedConfig)
    //         .map(([className, props]) => {
    //             const visibilityCSS = props.visible !== undefined
    //                 ? `display: ${props.visible ? 'block' : 'none'};`
    //                 : '';
    //             const dynamicStyles = Object.entries(props)
    //                 // .filter(([key]) => key !== 'visible')
    //                 .map(([key, value]) => `${key}: ${value};`)
    //                 .join(' ');
    //             return `${className} { ${visibilityCSS} ${dynamicStyles} }`;
    //         })
    //         .join(' ');
    //     styleTag.innerHTML = css;
    // };

    useEffect(() => {
        const loadHTML = async () => {
            req(`/html_design?id=${designId}`).then((design) => {
                setDesign(design);
                if (design.pages?.length == 1) {
                    setAllowedFormats(["png"]);
                } else {
                    setAllowedFormats(["pdf", "zip"]);
                    
                }
                setPreset({
                    height: design.height || preset.height,
                    width: design.width || preset.width,
                })
                
            });
        };
        loadHTML();
    }, [userInfo, designId]);

    useEffect(() => {
        if (!design || !design.pages[0]) return;

        // if crossorigin=anonymous is absent in any <link> tag, add it
        for (let i = 0; i < design.pages.length; i++) {
            let html = design.pages[i].html;
            const links = html.match(/<link[^>]+>/g);
            if (links) {
                for (let link of links) {
                    if (!link.includes('crossorigin')) {
                        const newLink = link.replace('>', ' crossorigin="anonymous">');
                        html = html.replace(link, newLink);
                    }
                }
            }
            html = html.replace('</head>', code + '</head>').replace(`
        const fontsDoneDiv = document.getElementById('fonts-done');
        if(document.fonts) {
            if (fontsDoneDiv) {
                fontsDoneDiv.remove();
            }
            document.fonts.ready.then(()=>{
                const marker=document.createElement('div')
                marker.id='fonts-done'
                document.body.appendChild(marker)
            })
        } else if(!fontsDoneDiv) {
            const marker=document.createElement('div')
            marker.id='fonts-done'
            document.body.appendChild(marker)
        }
    `, '')
            
            design.pages[i].html = html;
        }

        setHtmls(design.pages.map(page => {
            return page.html.replace('</head>', code + '</head>')
        }));
        setDesignLoading(false);
    }, [design])

    return (
        <div>
            <NavBar>
                
            </NavBar>
            
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
                padding: 20
            }}>
                
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    gap: 12, 
                    width: smallScreen ? "90%" : (design?.pages?.length == 1 ? preset.width : 800),
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <div>
                        {userInfo.subscription_type == "free-trial" && (
                            <div>
                                Please <a target="_blank" href="/choose-plan" style={{ textDecoration: 'underline' }}>upgrade</a> to remove the watermark
                            </div>
                        )}
                    </div>
                    
                    <div>
                        <DownloadButton designId={designId} allowedFormats={allowedFormats} setDownloading={setDownloading} setHtmls={setHtmls} setReceivedImages={setReceivedImages} framesRef={framesRef} setFormat={setFormat} screenshotPage={screenshotPage}/>
                    </div>
                    

                    {design?.pages?.length == 1 && (
                        <div style={{ 
                            display: 'flex', 
                            gap: 0, 
                            textAlign: "center",
                            justifyContent: 'start',
                        }}>
                            {presets.map((p, index) => (
                                <IconButton
                                    key={index}
                                    onClick={() => setPreset(p)}
                                    variant="outlined"
                                    color={preset.name === p.name ? 'primary' : 'default'}
                                >
                                    {p.icon}
                                </IconButton>
                            ))}
                        </div>
                    )}
                    
                    <HueSlider hue={hue} setHue={(h) => {
                        hue = h;
                        setHue(h);
                    }} onMouseUp={onHueSliderMouseUp}/>
                </div>
                {designLoading && <CircularProgress />}
                <EmblaCarouselIframes framesRef={framesRef} htmls={htmls} options={{ loop: false }} onIframeBlur={onIframeBlur}
                width={preset.width} height={preset.height} setCurrentSlide={setCurrentSlide} />
            </div>
            <DownloadOverlay downloading={downloading} downloadingPage={downloadingPage}/>

        </div>
    );
};

function DownloadOverlay({downloading, downloadingPage}) {
    return (
        <div>
            <div style={{ 
                display: downloading ? "block" : "none",
                background: "rgba(0, 0, 0, 0.8)",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1000,
            }}>
                <div style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}>
                    <div style={{
                        color: "white",
                        fontSize: 20,
                        fontWeight: "bold",
                        textAlign: "center",
                    }}>
                        <div style={{
                            marginBottom: 10,
                        }}>Preparing download {downloadingPage}...</div>
                        <CircularProgress />
                    </div>
                </div>
            </div>
        </div>
    )
}

function DownloadButton({designId, allowedFormats, setHtmls, setDownloading, setReceivedImages, setFormat, screenshotPage, framesRef}) {
    const [showHowToEdit, setShowHowToEdit] = useState(false);

    function download(format) {
        
        setDownloading(true);
        reqPoll(`/html_design?id=${designId}`, 'PUT', JSON.stringify({
            design_id: designId,
            pages: framesRef.current.map((iframe) => ({
                html: iframe.contentDocument.documentElement.outerHTML,
                template_html: "",
                config: {}
            })),
            formats: [format]
        })).then((res) => {
            if (format == "zip") {
                // download res.zip_url
                window.open(res.zip_url, '_blank');
            } else if (format == "pdf") {
                // download res.pdf_url
                window.open(res.pdf_url, '_blank');
            } else if (format == "png") {
                // download res.url
                window.open(res.url, '_blank');
            }
            // setAnchorEl(null);
            setDownloading(false);
            // const htmls = framesRef.current.map((iframe) => iframe.contentDocument.documentElement.outerHTML);
            // setHtmls(htmls);
            // setReceivedImages({});
            // setFormat(format);
            // setTimeout(() => {
            //     screenshotPage(0);
            // }, 2000); // todo: debug why 10 doesn't work, something to do with fonts?
        });
    }

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 8, 
                marginTop: 20
        }}>
            <Button variant="outlined" onClick={() => {
                setShowHowToEdit(true)
            }} style={{
                textTransform: 'none',
                marginBottom: 2,
            }}>Edit</Button>
            {allowedFormats.map((format) => (
                <Button key={format} variant="contained" style={{
                    textTransform: 'none',
                    marginBottom: 2,
                }} onClick={(e) => download(format)}>Download as {format.toUpperCase()}</Button>
            ))}
           
        </div>
        {showHowToEdit && <Alert color="primary" variant="outlined" severity="info" style={{ 
            width: '100%',
            marginTop: 20
        }}>Click on an image or text to edit it.</Alert>}
        </>
    )
}

const download = async ({format, images, setDownloading}) => {
    let pdf, zip;
    if (format == "pdf") {
        pdf = new jsPDF({ unit: "px", format: [800,800], compress: true });
    } else if (format == "zip") {
        zip = new JSZip();
    }

    for (let i = 0; i < images.length; i++) {
        const imgData = images[i];
        if (format == "zip") {
            const byteCharacters = atob(imgData.split(",")[1]);
            const byteNumbers = new Array(byteCharacters.length);
            for (let j = 0; j < byteCharacters.length; j++) {
                byteNumbers[j] = byteCharacters.charCodeAt(j);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const imgBlob = new Blob([byteArray], { type: "image/png" });
            zip.file(`slide-${i + 1}.png`, imgBlob);
        }

        if (format == "pdf") {
            const imgWidth = 800;
            const imgHeight = 800;
            try {
                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
            } catch(e) {
                console.error(e);
            }
        }
    }
    

    if (format == "pdf") {
        pdf.save("makemybrand-carousel.pdf");
    } else if (format == "zip") {
        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, "makemybrand-carousel.zip");
    } else if (format == "png") {
        const img = new Image();
        img.src = images[0];
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
                saveAs(blob, "makemybrand.png");
            });
        }
    }

    setTimeout(() => {
        setDownloading(false);
    }, 200);
  };

export default DesignEditor;
